import React from 'react';

interface EraserIconProps {
  className?: string;
  size?: number;
}

export const EraserIcon: React.FC<EraserIconProps> = ({ 
  className = "w-5 h-5", 
  size = 20 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Eraser body with organic shape */}
      <path
        d="M18 13L11 20L4 13L11 6L18 13Z"
        strokeWidth="1.5"
        fill="none"
      />
      {/* Eraser grip lines */}
      <path
        d="M7 11L15 11"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.6"
      />
      <path
        d="M7 15L15 15"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.6"
      />
      {/* Eraser action lines */}
      <path
        d="M2 22L22 22"
        strokeWidth="1"
        strokeLinecap="round"
        opacity="0.4"
        strokeDasharray="2 2"
      />
      {/* Subtle eraser shadow */}
      <path
        d="M18 13L11 20L4 13L11 6L18 13Z"
        stroke="currentColor"
        strokeWidth="0.5"
        opacity="0.3"
        strokeDasharray="1 1"
      />
    </svg>
  );
};

export default EraserIcon;
